var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BaseButton',{attrs:{"secondary":"","on-dark":""},on:{"click":_vm.importContacts}},[_vm._v(" "+_vm._s(_vm.$t('accountContacts.importContacts'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }